<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Link({
              label: 'Link',
              modelPath: [this, 'form', 'main_link'],
              required: true
            }),
            new fields.Switch({
              label: 'Podkreślenie',
              modelPath: [this, 'form', 'is_underlined']
            }),
            new fields.Switch({
              label: 'Strzałka',
              modelPath: [this, 'form', 'has_arrow']
            }),
            new fields.Switch({
              label: 'Efekt wysuwanej strzałki',
              modelPath: [this, 'form', 'is_hover']
            }),
            new fields.Switch({
              label: 'Efekt obracanego tekstu',
              modelPath: [this, 'form', 'is_rotated_text']
            }),
            new fields.Switch({
              label: 'Duży',
              modelPath: [this, 'form', 'is_big']
            })
          ]
        }
      ]
    }
  }
}
</script>
